export default {
  appointmentSchedule: 'User Appointment Schedule',
  patientAppointmentSchedule: 'Patient Appointment Schedule',
  inspectionSchedule: 'Inspection Schedule',
  doctorAppointmentSchedule: 'Doctor Appointment Schedule',
  selectAppointmentType: 'Select Appointment Type',
  selectAppointmentStatus: 'Select Appointment Status',
  selectEmployees: 'Select Employee',
  nextAppointment: 'Next Appointment',
  title: {
    createAppointment: 'Create Appointment',
    createdBy: 'Created By',
    createAppointmentTable: 'Create Appointment Table',
    addInspectionDay: 'Add Inspection Day',
    ExDetail: 'Inspection Day Details'
  },
  headers: {
    date: 'Date-Time Edited',
    editBy: 'Edited By',
    edit: 'Edit',
    oldData: 'Old Data',
    newData: 'New Data'
  },
  label: {
    oclock: 'hr',
    time: 'Appointment Time',
    duration: 'Duration',
    apmDate: 'From Date',
    branch: 'Branch',
    person: 'Person Appointed',
    timeEx: 'Inspection Time',
    appList: 'Appointment List',
    printDate: 'Printed On'
  },
  typeAppointment: {
    buyProduct: 'Buy Product',
    serviceTreatment: 'Treatment/Service',
    online: 'Online',
    counseling: 'Consultation'
  },
  alert: {
    successCreateAppointment: 'Successfully created patient appointment schedule!',
    addNextAppointmentToMedicalCertificate: 'Add the next appointment to the Medical Certificate / Short Medical Certificate / Treatment Certificate',
    confirmCancelTitle: 'Confirm Inspection Cancellation',
    confirmCancelDetail1: 'You are canceling the inspection appointment',
    confirmCancelDetail2: 'Do you want to proceed?',
    createExSucc: 'Inspection schedule created successfully!',
    todayHaveApp: 'Appointments already scheduled for today. Please check the appointment schedule.'
  },
  toolTip: {
    cancel: 'Cancel Appointment',
    cancelEx: 'Cancel Inspection Day',
    editEx: 'Edit Inspection Day'
  },
  placeholder: {
    plzSelectTime: 'Please select service duration',
    searchHnDateTreatment: 'Search HN, treatment date',
    selectRoom: 'Select Room'
  },
  modal: {
    delete: {
      titel: 'Confirm Appointment Cancellation',
      success: 'Inspection appointment cancelled successfully!'
    },
    edit: {
      title: 'Edit Appointment',
      success: 'Appointment edited successfully!',
      cannotMove: 'Cannot move inspection day! There are patients already scheduled.'
    }
  },
  error: 'An error occurred while saving the data'
}
